
import TitleBox from '@/components/CSS/TitleBox'
import TitleBox2 from '@/components/CSS/TitleBox2'
import { openServiceAuth } from '@/settings'
import { mapGetters } from 'vuex'
import { copyToClip } from '~/utils/index.js'
import { RestrictMallCode } from '@/enum/localEnum'

export default {
	middleware: 'intermediary-auth',
	components: {
		TitleBox
	},
	computed: {
		...mapGetters({
			userinfo: 'user/userinfo',
			token: 'user/token'
		})
	},
	data() {
		return {
			loading: null,
			guaranteeServiceListData: [],
			// 显示第二个titleBox标题
			showDesc: false,
			search: '',
			leftImg: '',
			title: '', // 标题
			titleBoxTitle: '', // 第一个titleBox标题
			descTitle: '', // 第二个titleBox标题
			articleContent: '<p class="tc f18 text-aaa mt-115">加载中...</p>', // 内容
			time: null, //查询时间
			accountNumber: null //查询账号
		}
	},
	head() {
		return {
			title: '交易担保-官方客服-盼之代售-手游网游账号买号卖号平台',
			meta: [
				{
					hid: 'description',
					name: 'description',
					content: '盼之代售，专业正规的游戏账号交易平台，中介担保签署正规法律合同。一手账号交易，专属客服1对1上架代售，提供包赔证明，永久包赔。'
				},
				{
					hid: 'keywords',
					name: 'keywords',
					content: '账号交易担保,游戏账号交易,盼之代售'
				}
			]
		}
	},

	mounted() {
		// 中介担保
		let title = '中介担保'
		if (title) {
			this.getPageData(title)
		}
	},
	methods: {
		join(e) {
			if (openServiceAuth && !this.token) {
				this.$message.warning('请先登录')
				this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
				return
			}

			// 检查是否被限制购买商品
			const isRestrict = this.$store?.getters?.['user/checkUserRestrictMall'](RestrictMallCode.AGENCY_BUY)
            if (isRestrict) { return }

			console.log('联系客服', e)
			if (e.imId) {
				this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 0)
				this.$store.dispatch('ry/join', { targetId: e.imId, conversationType: 1 })
				this.$store.commit('ry/SET_ORDER_FLOW_SHOW', false)
				this.$store.commit('ry/SET_ORDER_FLOW', [])
			}
		},
		copySuccess(val) {
			copyToClip(val, '已复制')
		},
		mathRandomList(arr) {
			arr.sort(() => {
				return Math.random() - 0.5
			})
		},
		back() {
			this.$router.go(-1)
		},
		convertKey(arr) {
			return arr.map(item => ({
				qqNo: item.qq,
				linkUrl: item.addUrl,
				remark: item.remark,
				...item
			}))
		},
		// 中介担保客服列表
		getGuaranteeServiceList() {
			this.$api.guarantee().then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.guaranteeServiceListData = this.convertKey(res.data)
				// this.mathRandomList(this.guaranteeServiceListData)
			})
		},
		getPageData(title) {
			switch (title) {
				case '中介担保':
					this.articleContent = ''
					this.showDesc = true
					this.leftImg = 'https://oss.pzds.com/imgv2/customer_service.png'
					this.title = '中介担保'
					this.titleBoxTitle = '官方客服'
					this.descTitle = '中介担保'
					this.getGuaranteeServiceList()
					break
				default:
					this.showDesc = false
					this.title = this.titleBoxTitle = title
			}
			this.getArticle()
		},
		getArticle() {
			let p = {
				action: {
					title: this.title
				}
			}
			this.$api.articleDetail(p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.articleContent = res.data ? res.data.content : '<p class="tc f18 text-aaa mt-115">暂无内容</p>'
			})
		}
	}
}
